import { PostLicenseProps, PostSignProps } from './types';
import http from '../httpService';

const headers = {
  accept: 'application/json, text/plain, */*',
  'content-type': 'application/json',
};

export const postLicense = async (data: PostLicenseProps) => {
  const response = await http.post(
    `${process.env.REACT_APP_BASE_URL}api/customer/license`,
    JSON.stringify(data),
    { headers },
  );
  return response;
};

export const getAgreement = async () => {
  const response = await http.get(
    `${process.env.REACT_APP_BASE_URL}api/customer/agreement`,
  );
  return response;
};

export const postSign = async (data: PostSignProps) => {
  const response = await http.post(
    `${process.env.REACT_APP_BASE_URL}api/customer/agreement/sign`,
    JSON.stringify(data),
    { headers },
  );
  return response;
};

export const updateCustomer = async (data: any) => {
  const response = await http.post(
    `${process.env.REACT_APP_BASE_URL}api/customer`,
    JSON.stringify(data),
    { headers },
  );
  return response;
};
